import { XStack } from '@lyra/core/components'
import BodyText from '@lyra/core/components/BodyText'
import { WEI_DECIMALS } from '@lyra/core/constants/contracts'
import formatUSD from '@lyra/core/utils/formatUSD'
import { CurrencyId } from '@lyra/web/constants/tokens'
import { forwardRef, Ref } from 'react'

type Props = {
  midpointPrice: number
  currencyId: CurrencyId
}

const OrderbookMidpoint = forwardRef(function TradeOrderbookMidpoint(
  { midpointPrice }: Props,
  ref: Ref<HTMLElement>
) {
  return (
    <XStack
      ref={ref}
      alignItems="center"
      justifyContent="center"
      paddingVertical="3px" // matches sm table row
      width="100%"
      borderColor="$hairline"
      borderTopWidth={1}
      borderBottomWidth={1}
    >
      <BodyText>{formatUSD(midpointPrice, { maxDps: WEI_DECIMALS })}</BodyText>
    </XStack>
  )
})

export default OrderbookMidpoint
